import { numericDateOptions } from "@iec-id/shared";

/**
 * Даты в интерфейсе: `23.02.2026` (ru) / `Feb 23, 2026` (en) — правило
 * форматирования из CLAUDE.md. Логика одна на все экраны входа, чтобы дата
 * вступления редакции в силу выглядела одинаково в баннере и в читалке.
 */
const formatters = new Map<string, Intl.DateTimeFormat>();

export function formatDate(iso: string, locale: string): string {
	let formatter = formatters.get(locale);
	if (!formatter) {
		// Набор полей — общее правило проекта из `@iec-id/shared`: копий этого
		// решения было три, и две из них (витрина, админка) знали его неверно.
		formatter = new Intl.DateTimeFormat(locale, numericDateOptions(locale));
		formatters.set(locale, formatter);
	}
	return formatter.format(new Date(iso));
}
